import { APPLICATION_STATE, SF_APP_STATE } from "../utility/constants/application-status";

export const APP_CONFIG_LOCAL_STORAGE_TTL = 15;
export const APP_CONFIG_UPDATED_TIME = "appConfigUpdatedTime";
export const IS_ADS_ENABLED = "isAdsEnabled";
export const IS_GLOBAL_ID_ENABLED = "isGlobalIdEnabled";
export const REQUISITION_CATEGORY = "REQUISITION_CATEGORY";
export const IS_JC_ENABLED = "isJobContainerEnabled";
export const IS_ATOZ_ENABLED = "isAtoZEnabled";
export const WORK_AUTHORIZATION_DOC_CONFIGS = "workAuthorizationDocumentConfigs";
export const HIDE_ATOZ_TASK = "hideAtoZTask";
export const TASK_FEATURE_FLAG_CONFIG = "task_feature_flag_config";
export const TASK_DEFINITION_CONFIG = "task_definition_config";
export const BADGE_PHOTO_TASK_ID = "BADGE_PHOTO_TASK";
export const I9_TASK_ID = "I9_TASK";
export const RIGHT_TO_WORK_TASK_DEFINITION_ID = "RIGHT_TO_WORK_TASK_DEFINITION";
export const NHE_VIDEO_TASK_ID = "NHE_VIDEO_TASK";
export const PACKAGE_I9_TASK_ID = "PACKAGE_I9_TASK";
export const BP_DURING_APPOINTMENT_TASK_ID = "BP_DURING_APPOINTMENT_TASK";
export const BGC_CHECK_IN_SCREENING_TASK_ID = "BGC_CHECK_IN_SCREENING_TASK";
export const AIR_BGC_IN_SCREENING_CHECK_TASK_ID = "AIR_BGC_IN_SCREENING_CHECK_TASK";
export const DT_IN_SCREENING_CHECK_TASK_ID = "DT_IN_SCREENING_CHECK_TASK";
export const PIC_IN_SCREENING_CHECK_TASK_ID = "PIC_IN_SCREENING_CHECK_TASK";
export const MYSP_TASK_ID = "MYSP_TASK";
export const EMPLOYMENT_PAPERWORK_TASK_ID = "EMPLOYMENT_PAPERWORK_TASK";
export const ATOZ_TASK_ID = "ATOZ_TASK";
export const DOCUMENT_TASK_ID = "DOCUMENT_TASK";
export const APPOINTMENT_DETAILS_TASK_ID = "APPOINTMENT_DETAILS_TASK";
export const MEDICAL_CHECK_IN_SCREENING_TASK_ID = "Medical_CHECK_IN_SCREENING_TASK";
export const BACKGROUND_CHECK_INFORMATION_ID = "BACKGROUND_CHECK_INFORMATION_TASK";
export const SCHEDULE_RIGHT_TO_WORK_APPOINTMENT_ID = "SCHEDULE_RIGHT_TO_WORK_APPOINTMENT_TASK";
export const CUSTOMER_SERVICE = "Customer Service";
export const NON_CUSTOMER_SERVICE = "Non Customer Service";
export type JobType = typeof CUSTOMER_SERVICE | typeof NON_CUSTOMER_SERVICE;
export const RIGHT_TO_WORK_TASK_TITLE = "RightToWork";

export const SDA_DATE_FORMAT = "ddd MMM DD";
export const JOB_DETAIL_DATE_FORMAT = "YYYY-MM-DD";
export const JOB_DETAIL_TIME_FORMAT = "HH:mm";
export const SDA_TIME_FORMAT = "hh:mmA";
export const AWAITING_CANDIDATE_INFO = "Awaiting Candidate Info";

export enum LAUNCHED_COUNTRY {
  US = "US",
  GB = "GB",
  MX = "MX",
}

export enum COUNTRIES_BACKGROUND_CHECK_ONLY {
  GB = LAUNCHED_COUNTRY.GB,
}

export enum COUNTRIES_WITHOUT_I9 {
  GB = LAUNCHED_COUNTRY.GB,
}

export enum COUNTRIES_WITH_VIRTUAL_NHE {
  GB = LAUNCHED_COUNTRY.GB,
}

// If the applicationState is READY_TO_HIRE should not display as a tentative days. https://issues.amazon.com/issues/Kondo_QA_Issue-552
// If the applicationState is HIRE_COMPLETE should not display as a tentative days. https://sim.amazon.com/issues/Kondo_QA_Issue-688
export const NOT_TENTATIVE_START_APPLICATION_STATES = [
  APPLICATION_STATE.READY_TO_HIRE,
  APPLICATION_STATE.HIRE_COMPLETE,
];

export const NOT_TENTATIVE_START_SF_STEP_SUBSTEP = [
  SF_APP_STATE.HIRED_CONTINGENT,
  SF_APP_STATE.HIRED_DIRECT,
  SF_APP_STATE.PRE_HIRE_INITIATE_ONBOARDING,
  SF_APP_STATE.PRE_HIRE_PEOPLE_SOFT,
];
export enum EMPLOYMENT_TYPE {
  REGULAR = "Regular",
  SEASONAL = "Seasonal",
  PERMANENT = "Permanent",
  FIXED_TERM = "Fixed_term",
}

// https://issues.amazon.com/issues/Kondo_QA_Issue-269
// Mapping data: https://code.amazon.com/packages/HVHCareersFrontendSearchWebsite/blobs/0f5dc65b995831abf317d2bb79f78aa6eec3e7cc/--/src/utils/filterOptions/index.ts#L33-L37
export const UK_EMPLOYMENT_TYPE_LABEL_OVERRIDE: Partial<Record<EMPLOYMENT_TYPE, EMPLOYMENT_TYPE>> = {
  [EMPLOYMENT_TYPE.REGULAR]: EMPLOYMENT_TYPE.PERMANENT,
  [EMPLOYMENT_TYPE.SEASONAL]: EMPLOYMENT_TYPE.FIXED_TERM,
};

export const SHOW_SCREENING_RESULT_VALID_STATES = [
  APPLICATION_STATE.CONTINGENCIES_PENDING,
  APPLICATION_STATE.START_DATE_CONFIRMATION_PENDING,
  APPLICATION_STATE.READY_TO_HIRE,
  APPLICATION_STATE.HIRE_COMPLETE,
  APPLICATION_STATE.SCHEDULE_SELECTION_PENDING,
];

// https://sim.amazon.com/issues/Kondo_QA_Issue-620
export const SHOW_SCREENING_RESULT_VALID_STATES_UK = [
  APPLICATION_STATE.PENDING_APPT_1_SCHEDULING,
  APPLICATION_STATE.APPT_1_PENDING,
];

// https://sim.amazon.com/issues/Kondo_QA_Issue-620
export const ADDITIONAL_VALID_APP_STATE_TO_DISPLAY_NHE_UK: string[] = [
  APPLICATION_STATE.PENDING_APPT_1_SCHEDULING,
  APPLICATION_STATE.APPT_1_PENDING,
];
